// Desktop-only bubble effect
if (!window.matchMedia('(max-width: 768px)').matches) {
  document.addEventListener('DOMContentLoaded', function() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    document.body.appendChild(canvas);
    
    // Style canvas (covers whole page but ignores clicks)
    canvas.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      pointer-events: none;
      z-index: 9999;
    `;
    
    // Resize handling
    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    window.addEventListener('resize', resize);
    resize();

    // Mouse tracking
    let mouseX = canvas.width / 2;
    let mouseY = canvas.height / 2;
    let mouseMoved = false;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      mouseMoved = true;
    });

    // Bubble class
    class Bubble {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.size = Math.random() * 4 + 2; // 2-6px
        this.opacity = Math.random() * 0.6 + 0.4;
        this.life = 30 + Math.random() * 20;
        this.speedX = (Math.random() - 0.5) * 2;
        this.speedY = (Math.random() - 0.5) * 2;
      }

      update() {
        this.x += (mouseX - this.x) * 0.1 + this.speedX;
        this.y += (mouseY - this.y) * 0.1 + this.speedY;
        this.opacity -= 0.02;
        this.life--;
      }

      draw() {
        // Shadow
        ctx.beginPath();
        ctx.arc(this.x + 1, this.y + 1, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(0, 0, 0, ${this.opacity * 0.2})`;
        ctx.fill();
        
        // Bubble
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(200, 240, 255, ${this.opacity})`;
        ctx.fill();
        
        // Highlight
        ctx.beginPath();
        ctx.arc(this.x - this.size * 0.3, this.y - this.size * 0.3, this.size * 0.3, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity * 0.6})`;
        ctx.fill();
      }
    }

    let bubbles = [];

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (mouseMoved && Math.random() < 0.5) {
        bubbles.push(new Bubble(mouseX, mouseY));
        mouseMoved = false;
      }

      for (let i = 0; i < bubbles.length; i++) {
        bubbles[i].update();
        bubbles[i].draw();

        if (bubbles[i].life <= 0 || bubbles[i].opacity <= 0) {
          bubbles.splice(i, 1);
          i--;
        }
      }

      requestAnimationFrame(animate);
    }

    animate();
  });
}